import { t } from '@lingui/macro'

import { ConfirmationModal } from '@/@bothrs-ui/web/components/confirmation-modal/ConfirmationModal'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type Props = InheritableModalProps & {
  onAction: () => void
}

export const DeleteContactModal = ({ onAction, ...props }: Props) => {
  return (
    <ConfirmationModal
      {...props}
      onAction={onAction}
      icon={['fal', 'question-circle']}
      title={t({
        message: 'Ben je zeker dat je deze contactpersoon wil verwijderen?',
      })}
      actionButtonText={t({
        message: 'Ja, verwijder',
      })}
      cancelButtonText={t({
        message: 'Annuleren',
      })}
    />
  )
}
